import * as Sentry from '@sentry/react';
import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
  SENTRY_APPLICATION_KEY,
} from '@ordermentum/ui-constants';

export * from '@sentry/react';

export const init = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    ignoreErrors: [
      'Request failed with status code',
      'React.cloneElement',
      'Network Error',
      /**
       * Example issue https://ordermentum.sentry.io/issues/6306090576/?environment=production&project=161878&query=release%3A2542cebc6b5ac551332d921e8728c35d4d1f0da5&referrer=release-issue-stream
       * This error seems to only be triggered in Windows > 10.
       * We have tried to filter as a third party error but it is not working.
       * Doing exact match for now to avoid being too broad.
       */
      /^Illegal invocation$/,
    ],
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: [SENTRY_APPLICATION_KEY],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
  });

  Sentry.addEventProcessor(event => {
    const processedEvent = { ...event };
    // @ts-expect-error Fullstory is not typed
    if (window.FS && window.FS.getCurrentSessionURL) {
      processedEvent.contexts = {
        ...processedEvent.contexts,
        fullStory: {
          // @ts-expect-error Fullstory is not typed
          url: window.FS.getCurrentSessionURL(),
        },
      };
    }

    return processedEvent;
  });
};
